import React from 'react';
import { Card } from './ui/Card';
import { ArrowUpRight, ArrowDownRight, Minus } from 'lucide-react';
interface StatCardProps {
  label: string;
  value: string | number;
  change?: number;
  trend?: 'up' | 'down' | 'neutral';
  icon: React.ElementType;
  color?: string;
}
export function StatCard({
  label,
  value,
  change,
  trend,
  icon: Icon,
  color = 'indigo'
}: StatCardProps) {
  const getColorClasses = (colorName: string) => {
    const colors: Record<string, string> = {
      indigo: 'bg-indigo-50 text-indigo-600',
      blue: 'bg-blue-50 text-blue-600',
      emerald: 'bg-emerald-50 text-emerald-600',
      amber: 'bg-amber-50 text-amber-600',
      purple: 'bg-purple-50 text-purple-600'
    };
    return colors[colorName] || colors.indigo;
  };
  return <Card className="flex flex-col justify-between h-full" data-id="element-39">
      <div className="flex items-start justify-between" data-id="element-40">
        <div data-id="element-41">
          <p className="text-sm font-medium text-gray-500" data-id="element-42">{label}</p>
          <h3 className="mt-2 text-3xl font-bold text-gray-900" data-id="element-43">{value}</h3>
        </div>
        <div className={`p-2 rounded-lg ${getColorClasses(color)}`} data-id="element-44">
          <Icon className="h-6 w-6" data-id="element-45" />
        </div>
      </div>

      {change !== undefined && <div className="mt-4 flex items-center text-sm" data-id="element-46">
          {trend === 'up' && <ArrowUpRight className="mr-1 h-4 w-4 text-green-500" data-id="element-47" />}
          {trend === 'down' && <ArrowDownRight className="mr-1 h-4 w-4 text-red-500" data-id="element-48" />}
          {trend === 'neutral' && <Minus className="mr-1 h-4 w-4 text-gray-500" data-id="element-49" />}

          <span className={`font-medium ${trend === 'up' ? 'text-green-600' : trend === 'down' ? 'text-red-600' : 'text-gray-600'}`} data-id="element-50">
            {change > 0 ? '+' : ''}
            {change}%
          </span>
          <span className="ml-2 text-gray-500" data-id="element-51">from last month</span>
        </div>}
    </Card>;
}